import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { Grid } from './Grid';
import { Screen } from './Screen';
export const UngroupedScreens = observer(function UngroupedScreens({ aspectRatio, isExternalPrototype, onSelectScreen, otherScreen, screens, searchTerm, selectedScreen, }) {
    return (_jsx(Grid, { children: screens.map((screen) => (_jsx(Screen, { aspectRatio: aspectRatio, disabled: screen.pk === otherScreen, isActive: screen.pk === selectedScreen, isWaitingOnFigma: isExternalPrototype && screen.content === null, onSelectScreen: onSelectScreen, screenData: screen, searchTerm: searchTerm }, screen.pk))) }));
});
